export function LegendPlaceholder() {
  return (
    <div className="flex gap-6 items-center justify-start">
      <div style={{ width: 100, height: 40 }} />
    </div>
  )
}
